import { TimeDimensionGranularity } from '@cubejs-client/core';
import { useCubeQuery } from '@cubejs-client/react';
import { StackedBarChartProps } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import {
  DemandRecommendationDimensions,
  DemandRecommendationMeasures,
} from '~/common/types/cubes/DemandRecommendation';
import { useDateRange } from '~/components/DateRangeProvider';
import { convertDateRangeToTimeDimension, getSegments } from '~/util/cube';

export interface UseOrderVolumeCommodityResult {
  title: string;
  subTitle: string;
  data: StackedBarChartProps['data'];
  dataConfig: StackedBarChartProps['dataConfig'];
  xAxis: StackedBarChartProps['xAxis'];
  yAxis: StackedBarChartProps['yAxis'];
  isLoading: boolean;
}
const GRANULARITY: TimeDimensionGranularity = 'month';

export const usePercentageOfDemandsWithRecommendationsCubeQuery = () => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'PercentageOfDemandsWithRecommendationsWidget' });
  const { currentDateRange } = useDateRange();

  const timeDimensions = convertDateRangeToTimeDimension(
    DemandRecommendationDimensions.CREATED_AT,
    currentDateRange,
    GRANULARITY,
  );

  const totalCountQuery = useCubeQuery({
    measures: [DemandRecommendationMeasures.DEMANDS_WITH_RECOMMENDATIONS_COUNT],
    timeDimensions,
  });

  const recommendationQuery = useCubeQuery({
    measures: [DemandRecommendationMeasures.PERCENTAGE_RECOMMENDATIONS],
    timeDimensions,
  });

  const { totalValue } = getSegments(totalCountQuery);

  const { isLoading } = recommendationQuery;

  return {
    title: t('title'),
    subTitle: t('subTitle'),
    chartCaption: t('chartCaption'),
    chartCaptionTooltip: t('chartCaptionTooltip'),
    isLoading,
    totalValue,
    queryValue: recommendationQuery,
  };
};
